import { UserData } from './types'

export const fetchData = (
  isExternal: boolean,
  gridName: string,
  queryUserId: number,
  queryCustId: number,
  startDate: Date,
  endDate: Date
) =>
  ({
    type: `userData.fetchData`,
    payload: {
      isExternal,
      gridName,
      queryUserId,
      queryCustId,
      startDate,
      endDate
    }
  } as const)
export type FetchAction = ReturnType<typeof fetchData>

export const addData = (data: UserData[], gridName: string) =>
  ({
    type: `userData.addData`,
    payload: { data, gridName }
  } as const)
export type AddAction = ReturnType<typeof addData>

export const fetchFail = (error: string, gridName: string) =>
  ({
    type: `userData.fetchFail`,
    payload: { error, gridName },
    error: true
  } as const)

export type FailAction = ReturnType<typeof fetchFail>

export type UserDataAction = FetchAction | AddAction | FailAction
